import * as React from 'react';
import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect';
/**
 * Хук для создания колбэков не подверженных инвалидации
 *
 * @export
 * @template T
 * @param {T} callback
 * @returns {T}
 */

export function useEventCallback(callback) {
  var ref = React.useRef(callback);
  useIsomorphicLayoutEffect(function () {
    ref.current = callback;
  });
  return React.useCallback(function () {
    return (void 0, ref.current).apply(void 0, arguments);
  }, []);
}